var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 0C9.45017 0 9.00017 0.45 9.00017 1V9C9.00017 9.55 9.45017 10 10.0002 10C10.5502 10 11.0002 9.55 11.0002 9V1C11.0002 0.45 10.5502 0 10.0002 0ZM15.1402 2.86C14.7502 3.25 14.7602 3.86 15.1302 4.25C16.2602 5.45 16.9602 7.05 17.0002 8.82C17.0902 12.65 13.9202 15.95 10.0902 15.99C6.18017 16.05 3.00017 12.9 3.00017 9C3.00017 7.16 3.71017 5.49 4.87017 4.24C5.24017 3.85 5.24017 3.24 4.86017 2.86C4.46017 2.46 3.81017 2.47 3.43017 2.88C1.98017 4.42 1.07017 6.47 1.00017 8.74C0.860175 13.62 4.83017 17.84 9.71017 17.99C14.8102 18.15 19.0002 14.06 19.0002 8.99C19.0002 6.62 18.0802 4.48 16.5802 2.88C16.2002 2.47 15.5402 2.46 15.1402 2.86Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0f2183854467b4f366fa0d95391a1b0a.svg";
export { ForwardRef as ReactComponent };